module.exports = __webpack_public_path__ + "static/img/logo_04.e87bc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/logo_04.png
// module id = VZgp
// module chunks = 0